var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { retryTillPromiseResolves } from 'hx-util';
import { useCallback, useReducer, useRef } from 'react';
import logger from 'use-reducer-logger';
import { PlayMode } from '../player';
import WebAudioPlayer from '../player/web_audio';
import { useAudioPlayerContext } from './../../../hx-audio-player/src/hooks/useAudioContextContext';
var initialState = {
    initialized: false,
    status: 'idle',
    progress: 0,
};
var reducer = function (state, action) {
    switch (action.type) {
        case 'INITIALIZE':
            return __assign(__assign({}, state), { status: 'initializing', initialized: false });
        case 'INITIALIZE_SUCCESS':
            return __assign(__assign({}, state), { status: 'ready', initialized: true });
        case 'INITIALIZE_FAILURE':
            return __assign(__assign({}, state), { status: 'error', error: action.error });
        case 'SET_PROGRESS':
            return __assign(__assign({}, state), { progress: action.progress });
        case 'PLAY_TRIPLET':
            return __assign(__assign({}, state), { status: 'playing' });
        case 'PLAY_TRIPLET_SUCCESS':
            return __assign(__assign({}, state), { status: 'ready' });
        case 'PLAY_TRIPLET_FAILURE':
            return __assign(__assign({}, state), { status: 'error', error: action.error });
        default:
            return state;
    }
};
/**
 *
 * @remarks
 * When in strict mode, the  reducer is called twice, so the debug log will be called twice.
 */
export var useDinPlayer = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.debug, debug = _c === void 0 ? process.env.REACT_APP_DEBUG === 'true' : _c, _d = _b.audioSetName, audioSetName = _d === void 0 ? 'en_us_digits' : _d, _e = _b.extraAudioSetNames, extraAudioSetNames = _e === void 0 ? [] : _e, _f = _b.playMode, playMode = _f === void 0 ? PlayMode.BinauralOutOfPhase : _f, onInitialized = _b.onInitialized;
    var playerRef = useRef();
    var player = playerRef.current;
    var _g = useAudioPlayerContext(), audioContext = _g.audioContext, masterGain = _g.masterGain;
    var _h = useReducer(debug ? logger(reducer) : reducer, initialState), state = _h[0], dispatch = _h[1];
    var initialize = function () {
        return new Promise(function (resolve, reject) {
            dispatch({ type: 'INITIALIZE' });
            playerRef.current = new WebAudioPlayer(audioContext, masterGain);
            playerRef.current
                .loadAudio(__spreadArray([audioSetName], extraAudioSetNames, true), function (progress) {
                dispatch({ type: 'SET_PROGRESS', progress: progress });
            })
                .catch(function () {
                dispatch({
                    type: 'INITIALIZE_FAILURE',
                    error: new Error('Failed to load audio'),
                });
                reject();
            })
                .then(function () {
                dispatch({ type: 'INITIALIZE_SUCCESS' });
                onInitialized === null || onInitialized === void 0 ? void 0 : onInitialized();
                resolve();
            });
        });
    };
    var playTriplet = useCallback(function (triplet, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.setName, setName = _c === void 0 ? audioSetName : _c, _d = _b.playMode, tripletPlayMode = _d === void 0 ? playMode : _d, _e = _b.snr, snr = _e === void 0 ? 0 : _e, _f = _b.noCarrier, noCarrier = _f === void 0 ? false : _f, _g = _b.noNoise, noNoise = _g === void 0 ? false : _g;
        return __awaiter(void 0, void 0, void 0, function () {
            var attempt;
            return __generator(this, function (_h) {
                attempt = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!player)
                                    return [2 /*return*/];
                                if (!!state.initialized) return [3 /*break*/, 2];
                                return [4 /*yield*/, initialize()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 4, , 5]);
                                dispatch({ type: 'PLAY_TRIPLET' });
                                return [4 /*yield*/, player.playTriplet(setName, tripletPlayMode, snr, triplet, noCarrier, noNoise)];
                            case 3:
                                _a.sent();
                                dispatch({ type: 'PLAY_TRIPLET_SUCCESS' });
                                return [2 /*return*/];
                            case 4:
                                error_1 = _a.sent();
                                console.error('error playing triplet', error_1);
                                dispatch({ type: 'PLAY_TRIPLET_FAILURE', error: error_1 });
                                return [2 /*return*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); };
                return [2 /*return*/, retryTillPromiseResolves(attempt)];
            });
        });
    }, [state.status, state.initialized]);
    var stop = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!player) return [3 /*break*/, 2];
                    return [4 /*yield*/, player.stop()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [state.status]);
    return {
        state: state,
        stop: stop,
        initialize: initialize,
        playTriplet: playTriplet,
    };
};
var delay = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
